import React from 'react';
import './BlogsCard.scss';

export default function BlogsCard({image, heading}) {
  console.log('image is: ', image);
  return (
    <div className='blogs-card-container'>
      <div className='blog-image-container'>
        <img src={image} alt={heading} />
      </div>
      <h3>{heading}</h3>
    </div>
  )
}
